import type { HTMLOrSVGElement } from '../engine/types'

export function isHTMLOrSVG(el: Node): el is HTMLOrSVGElement {
  return el instanceof HTMLElement || el instanceof SVGElement
}

export function walkDOM(
  element: Node,
  callback: (el: HTMLOrSVGElement) => void,
) {
  const iter = document.createTreeWalker(
    element,
    1 /* NodeFilter.SHOW_ELEMENT */,
  )
  while (element) {
    if (isHTMLOrSVG(element)) {
      const dataset = element.dataset
      if ('ignore' in dataset) {
        element = iter.nextSibling()!
        continue
      }
      if (!('ignore__self' in dataset)) {
        callback(element)
      }
    }
    element = iter.nextNode()!
  }
}
